/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Drop_LabelInputs */



/**
* | output |
* | --- |
* | "Drop a CSV file here or click to browse" |
*
* @param {Team_Manager_Import_Drop_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_drop_label = /** @type {((inputs?: Team_Manager_Import_Drop_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Drop_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déposez un fichier CSV ici ou cliquez pour parcourir")
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV-Datei hier ablegen oder zum Durchsuchen klicken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascina qui un file CSV o fai clic per sfogliare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перетащите CSV-файл сюда или нажмите, чтобы выбрать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suelta un archivo CSV aquí o haz clic para buscarlo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将 CSV 文件拖放到此处，或点击浏览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSV ファイルをここにドロップするか、クリックして選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV फ़ाइल यहाँ छोड़ें या ब्राउज़ करने के लिए क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Largue aqui um ficheiro CSV ou clique para procurar")
	return /** @type {LocalizedString} */ ("Drop a CSV file here or click to browse")
});